/**

The MIT License (MIT)

Copyright (c) 2014 Rafael Garrido Romero

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

https://github.com/rgarom/angular-visualize-directive

*/
import angular from 'angular';
import swal from 'sweetalert';

export const loadModule = () =>
  angular
    .module('app')
    .directive('visualize', function visualize($window, $timeout) {
      return {
        restrict: 'E',
        transclude: true,
        scope: {
          resource: '=',
          params: '=',
          token: '=',
          isLoaded: '=',
        },
        template: '<div ng-transclude></div>',
        link(scope) {
          function callVisualize() {
            $window.visualize(
              {
                auth: {
                  token: scope.token,
                  preAuth: true,
                  tokenName: 'pp',
                },
              },

              () => {},

              (err) => {
                swal('Authentication Error', `Server response: ${err.message}`);
              },
            );
          }

          function callTimer() {
            $timeout(() => {
              callIsLoaded();
            }, 500);
          }

          function callIsLoaded() {
            if (typeof visualize !== 'undefined') {
              callVisualize();
            } else {
              callTimer();
            }
          }

          if (angular.isDefined(scope.resource)) {
            callTimer();
          }
        },
      };
    });
